import React from 'react'

export default function Services() {
    return (
        <>
            <div className="" style={{ backgroundColor: '#EEEEEE' }} id="services">
                <div className="container pb-5">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2 pt-5">
                                <h1 className="title mb-4" style={{ color: 'black'}}>Our Food</h1>
                                <p className="text-muted para-desc mx-auto mb-0">
                                Come & experience our best of world-class coffee and finger-licking food. Home to  the best cuisine
                                </p>
                            </div>
                        </div>
                        {/*end col*/}
                    </div>
                    {/*end row*/}
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div className="card" style={{'borderRadius': '2em'}}>
                                <div className="card-body">
                                    <div className="p-3 mt-2">
                                        <h3 className="text-custom pb-3" style={{color: '#42A2C3'}}><b>Coffee</b></h3>
                                        <p className="card-text pt-3">
                                            An end-to-end, web-based POS that has everything you need to manage your restaurant or cafe.
                                        </p>
                                    </div>
                                </div>
                                <img
                                    className="card-img-top"
                                    src="https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"                             
                                    alt="Card image1 cap"
                                    style={{'borderBottomLeftRadius' : '2em', 'borderBottomRightRadius' : '2em', height : '235px'}}
                                />
                                
                            </div>
                        </div>
                        {/*end col*/}
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div className="card" style={{'borderRadius': '2em'}}>
                                <div className="card-body">
                                    <div className="p-3 mt-2">
                                        <h3 className="text-custom pb-3" style={{color: '#42A2C3'}}><b>Tea</b></h3>
                                        <p className="card-text pt-3">
                                        Accept new orders and process it seamlessly with our order management service.
                                        </p>
                                    </div>
                                </div>
                                <img
                                    className="card-img-top"
                                    src="https://images.slurrp.com/prod/articles/g86cqsnvd9t.webp"
                                    alt="Card image1 cap"
                                    style={{'borderBottomLeftRadius' : '2em', 'borderBottomRightRadius' : '2em', height : '235px'}}
                                />
                            </div>
                        </div>
                        {/*end col*/}
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div className="card" style={{'borderRadius': '2em'}}>
                                <div className="card-body">
                                    <div className="p-3 mt-2">
                                        <h3 className="text-custom pb-3" style={{color: '#42A2C3'}}><b>Mocktails</b></h3>
                                        <p className="card-text pt-3">
                                        Accept payments quickly, easily & securely. Let shoppers pay their way with multiple payment options.
                                        </p>
                                    </div>
                                </div>
                                <img
                                    className="card-img-top"
                                    src="https://icytales.com/wp-content/uploads/2022/04/31764942526_1d2df00beb_k-1-scaled.webp"
                                    alt="Card image1 cap"
                                    style={{'borderBottomLeftRadius' : '2em', 'borderBottomRightRadius' : '2em', height : '235px'}}
                                />
                            </div>
                        </div>
                        {/*end col*/}
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div className="card" style={{'borderRadius': '2em'}}>
                                <div className="card-body">
                                    <div className="p-3 mt-2">
                                        <h3 className="text-custom pb-3" style={{color: '#42A2C3'}}><b>Pizza</b></h3>
                                        <p className="card-text pt-3">
                                        Provide a contactless ordering experience, accept payments & more with your store’s QR code.
                                        </p>
                                    </div>
                                </div>
                                <img
                                    className="card-img-top"
                                    src="https://static.toiimg.com/thumb/51892394/10-best-mid-range-Italian-Pizzeria-in-Gurgaon.jpg?width=1200&height=900"
                                    alt="Card image1 cap"
                                    style={{'borderBottomLeftRadius' : '2em', 'borderBottomRightRadius' : '2em', height : '235px'}}
                                />
                            </div>
                        </div>
                        {/*end col*/}
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div className="card" style={{'borderRadius': '2em'}}>
                                <div className="card-body">
                                    <div className="p-3 mt-2">
                                        <h3 className="text-custom pb-3" style={{color: '#42A2C3'}}><b>Pasta</b></h3>
                                        <p className="card-text pt-3">
                                        Adding new dishes to your menu? Manage your menu hasslefree with our system.
                                        </p>
                                    </div>
                                </div>
                                <img
                                    className="card-img-top"
                                    src="https://images.immediate.co.uk/production/volatile/sites/2/2020/05/olive_CreamySausagebake_preview-9e20f3d-e1646924183862.jpg?quality=90&resize=700,466"
                                    alt="Card image1 cap"
                                    style={{'borderBottomLeftRadius' : '2em', 'borderBottomRightRadius' : '2em', height : '235px'}}
                                />
                            </div>
                        </div>
                        {/*end col*/}
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                            <div className="card" style={{'borderRadius': '2em'}}>
                                <div className="card-body">
                                    <div className="p-3 mt-2">
                                        <h3 className="text-custom pb-3" style={{color: '#42A2C3'}}><b>Burger and More</b></h3>
                                        <p className="card-text pt-3">
                                        We provide most reliable way to your bill customers with our system design to improve operational efficiency.
                                        </p>
                                    </div>
                                </div>
                                <img
                                    className="card-img-top"
                                    src="https://media.istockphoto.com/photos/hamburger-with-cheese-and-french-fries-picture-id1188412964?k=20&m=1188412964&s=612x612&w=0&h=Ow-uMeygg90_1sxoCz-vh60SQDssmjP06uGXcZ2MzPY="
                                    alt="Card image1 cap"
                                    style={{'borderBottomLeftRadius' : '2em', 'borderBottomRightRadius' : '2em', height : '235px'}}
                                />
                            </div>
                        </div>
                        {/*end col*/}
                    </div>
                    {/*end row*/}
                </div>

            </div>
        </>
    )
}
